import { paths } from 'src/routes/paths';

import packageJson from '../package.json';

// ----------------------------------------------------------------------

export type ConfigValue = {
  appName: string;
  appVersion: string;
  serverUrl: string;
  assetsDir: string;
  apiBaseUrl: string;
  auth: {
    method: 'jwt' | 'amplify' | 'firebase' | 'supabase' | 'auth0';
    skip: boolean;
    redirectPath: string;
  };
  mapboxApiKey: string;
  firebae_emulator: {
    host: string,
    auth_port: number,
    firestore_port: number,
    storage_port: number,
    functions_port: number
  };
  firebase: {
    appId: string;
    apiKey: string;
    projectId: string;
    authDomain: string;
    storageBucket: string;
    measurementId: string;
    messagingSenderId: string;
    functionsHttpUrl: string;
    databaseId: string;
  };
  azure: { tenantId: string };
  amplify: { userPoolId: string; userPoolWebClientId: string; region: string };
  auth0: { clientId: string; domain: string; callbackUrl: string };
  supabase: { url: string; key: string };
  services: {
    openmeter: {
      baseUrl: string;
      apiKey: string;
      customerId: string;
      subscriptionId: string;
      customerKey: string;
      startPeriod: string;
    };
    redash: {
      dashboardUrl: string;
      dashboardRDBUrl: string;
    };
  }
};

// ----------------------------------------------------------------------

export const CONFIG: ConfigValue = {
  appName: 'Bayern-Fass AI',
  appVersion: packageJson.version,
  serverUrl: import.meta.env.VITE_SERVER_URL ?? '',
  assetsDir: import.meta.env.VITE_ASSETS_DIR ?? '',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api',
  /**
   * Auth
   * @method jwt | amplify | firebase | supabase | auth0
   */
  auth: {
    method: 'firebase',
    skip: false,
    redirectPath: paths.dashboard.root // paths.apps.root,
  },
  /**
   * Mapbox
   */
  mapboxApiKey: import.meta.env.VITE_MAPBOX_API_KEY ?? '',
  /**
   * Firebase
   */
  firebae_emulator: {
    host: import.meta.env.VITE_FIREBASE_EMULATOR_HOST ?? '',
    auth_port: import.meta.env.VITE_FIREBASE_EMULATOR_AUTH_PORT ?? 0,
    firestore_port: import.meta.env.VITE_FIREBASE_EMULATOR_FIRESTORE_PORT ?? 0,
    storage_port: import.meta.env.VITE_FIREBASE_EMULATOR_STORAGE_PORT ?? 0,
    functions_port: import.meta.env.VITE_FIREBASE_EMULATOR_FUNCTIONS_PORT ?? 0
  },
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? '',
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? '',
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? '',
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? '',
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '',
    appId: import.meta.env.VITE_FIREBASE_APPID ?? '',
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID ?? '',
    functionsHttpUrl: import.meta.env.VITE_FIREBASE_FUNCTIONS_HTTP_URL ?? '',
    databaseId : import.meta.env.VITE_FIREBASE_DATABASE_ID ?? ''
  },
  /**
   * Azure AD (Microsoft OAuth)
   */
  azure: {
    tenantId: import.meta.env.VITE_AZURE_TENANT_ID ?? '',
  },
  /**
   * Amplify
   */
  amplify: {
    userPoolId: import.meta.env.VITE_AWS_AMPLIFY_USER_POOL_ID ?? '',
    userPoolWebClientId: import.meta.env.VITE_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID ?? '',
    region: import.meta.env.VITE_AWS_AMPLIFY_REGION ?? '',
  },
  /**
   * Auth0
   */
  auth0: {
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID ?? '',
    domain: import.meta.env.VITE_AUTH0_DOMAIN ?? '',
    callbackUrl: import.meta.env.VITE_AUTH0_CALLBACK_URL ?? '',
  },
  /**
   * Supabase
   */
  supabase: {
    url: import.meta.env.VITE_SUPABASE_URL ?? '',
    key: import.meta.env.VITE_SUPABASE_ANON_KEY ?? '',
  },
  services: {
    openmeter: {
      baseUrl: import.meta.env.VITE_OPENMETER_BASE_URL ?? '',
      apiKey: import.meta.env.VITE_OPENMETER_API_KEY ?? '',
      customerId: import.meta.env.VITE_OPENMETER_BILLING_CUSTOMER_ID ?? '',
      customerKey: import.meta.env.VITE_OPENMETER_BILLING_CUSTOMER_KEY ?? '',
      subscriptionId: import.meta.env.VITE_OPENMETER_BILLING_SUBSCRIPTION_ID,
      startPeriod: import.meta.env.VITE_OPENMETER_BILLING_START_PERIOD ?? ''
    },
    redash: {
      dashboardUrl: import.meta.env.VITE_REDASH_DASHBOARD_URL ?? '',
      dashboardRDBUrl: import.meta.env.VITE_REDASH_RDB_DASHBOARD_URL ?? '',
    }
  }
};
